import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ButtonModule, SharedModule, InputTextModule, TooltipModule, FileUploadModule, DropdownModule, CalendarModule, AutoCompleteModule, RadioButtonModule, ProgressSpinnerModule } from 'primeng/primeng';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SibBackModule } from '../shared/components/sib-back/sib-back.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    ButtonModule,
    SharedModule,
    InputTextModule,
    TooltipModule,
    FileUploadModule,
    DropdownModule,
    CalendarModule,
    AutoCompleteModule,
    RadioButtonModule,
    ProgressSpinnerModule,
    SibBackModule
  ],
  declarations: [
    UserProfileComponent
  ],
  exports: [
    UserProfileComponent
  ]
})
export class UserProfileModule { }
